import { useEffect, useState } from 'react';
import { useStore } from '../core/store';

// Display contact form for agency INKASSO="" bookings with missing client contact informations
export function useContactInformationForm() {
  const { BookingStore } = useStore();
  const booking = BookingStore?.booking?.data;

  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (booking && booking?.isMissingClientInfo) {
      setShowForm(true);
    }
  }, [booking]);

  return { showForm, setShowForm };
}
